import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrivedAtPatient = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_4502_29414",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_4502_29414)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10 12C10.6806 12 11.3194 11.8507 11.9167 11.5521C12.5139 11.2535 12.9861 10.8125 13.3333 10.2292C12.8472 9.85417 12.3229 9.55556 11.7604 9.33333C11.1979 9.11111 10.6111 9 10 9C9.38889 9 8.80208 9.11111 8.23958 9.33333C7.67708 9.55556 7.15278 9.85417 6.66667 10.2292C7.01389 10.8125 7.48611 11.2535 8.08333 11.5521C8.68056 11.8507 9.31944 12 10 12ZM10 8C10.4167 8 10.7708 7.85417 11.0625 7.5625C11.3542 7.27083 11.5 6.91667 11.5 6.5C11.5 6.08333 11.3542 5.72917 11.0625 5.4375C10.7708 5.14583 10.4167 5 10 5C9.58333 5 9.22917 5.14583 8.9375 5.4375C8.64583 5.72917 8.5 6.08333 8.5 6.5C8.5 6.91667 8.64583 7.27083 8.9375 7.5625C9.22917 7.85417 9.58333 8 10 8ZM10 18C7.81944 16.1806 6.19097 14.4896 5.11458 12.9271C4.03819 11.3646 3.5 9.90972 3.5 8.5625C3.5 6.70139 4.11806 5.14236 5.35417 3.88542C6.59028 2.62847 8.13889 2 10 2C11.8472 2 13.3924 2.62847 14.6354 3.88542C15.8785 5.14236 16.5 6.70139 16.5 8.5625C16.5 9.90972 15.9653 11.3611 14.8958 12.9167C13.8264 14.4722 12.1944 16.1667 10 18Z",
			fill: "#1C1B1F"
		})
	})]
});
export default SvgArrivedAtPatient;
